/* istanbul ignore file */
export const getLegalIdentifierNumberFieldStyles = () => ({
  grayHint: {
    color: 'gray',
    marginTop: '10px',
  },
  legalIdentifierNumberField: ({ visuallyHidden }) => ({
    ...(visuallyHidden && {
      display: 'none',
    }),
  }),
});
